import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews, IconReviewStar } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError } = props;

  let ratingSum = 0;

  if( Array.isArray( reviews ) && reviews.length > 0 ) {
    reviews.forEach(r => {
      ratingSum += r.attributes.rating;
    });
  }

  return (
    <section className={css.sectionReviews}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.reviewsTitle" />
        <IconReviewStar className={css.reviewStar} isFilled={true}/>
        { Array.isArray( reviews ) && reviews.length > 0 ? (
          `${Math.round( ratingSum / reviews.length * 10 ) / 10} ( ${reviews.length} )`
        ) : (
          '0 ( 0 )'
        )}
      </Heading>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      <Reviews reviews={reviews} />
    </section>
  );
};

export default SectionReviews;
